export default __webpack_public_path__ + "static/eyes-2002a312fd63cc90c6371f5ffec08c58.svg";